var React = require('react');

function Paragraph (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9,12 C7.346,12 6,10.654 6,9 C6,7.346 7.346,6 9,6 L9,12 Z M20,4 L9,4 C6.243,4 4,6.243 4,9 C4,11.757 6.243,14 9,14 L9,19 C9,19.553 9.447,20 10,20 C10.553,20 11,19.553 11,19 L11,6 L15,6 L15,19 C15,19.553 15.447,20 16,20 C16.553,20 17,19.553 17,19 L17,6 L20,6 C20.553,6 21,5.552 21,5 C21,4.448 20.553,4 20,4 Z","id":"path-1"}));
}

Paragraph.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"currentColor","stroke":"none"};

module.exports = Paragraph;

Paragraph.default = Paragraph;
